// extracted by mini-css-extract-plugin
module.exports = {"loadingIcon":"LoadingIcon__loadingIcon","spin-1a852fb9":"LoadingIcon__spin-1a852fb9","loadingIconLarge":"LoadingIcon__loadingIconLarge"};